import React, { useState } from 'react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="py-6 bg-[#112945] relative z-10">
      <div className="max-w-7xl mx-auto px-4">
        <nav className="flex justify-between items-center">
          {/* Logo */}
          {/* <a href="/">
            <img src={Logo} className="w-40" alt="Sinoclear Logo" />
          </a> */}
           <h1 className='text-3xl font-semibold text-white'>
              Lung Renew
            </h1>

          {/* Desktop Navigation */}
          <div className="hidden md:flex gap-8 items-center">
            <a href="#features" className="text-white hover:text-gray-200">
              About Lung Renew
            </a>
            <a href="#science-back" className="text-white hover:text-gray-200">
              Ingredients
            </a>
            <a href="#faqs" className="text-white hover:text-gray-200">
              FAQ
            </a>
            {/* <button className="bg-blue-100 text-navy-900 px-6 py-2 rounded-md text-base font-semibold hover:bg-white hover:-translate-y-1 duration-150 ease-in-out">
              Order Now
            </button> */}
            <a
              href="#pricing"
              className="bg-blue-100 text-navy-900 px-6 py-2 rounded-md text-base font-semibold hover:bg-white hover:-translate-y-1 duration-150 ease-in-out"
            >
              Order Now
            </a>
          </div>

          {/* Mobile Toggle Button */}
          <button
            onClick={toggleMenu}
            className="md:hidden text-white focus:outline-none"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16m-7 6h7"
              />
            </svg>
          </button>
        </nav>
      </div>
      <div className={`fixed top-0 left-0 w-full bg-[#122B4A] shadow-lg transform origin-top transition-transform duration-300 ease-in-out z-50 ${isMenuOpen ? 'scale-y-100' : 'scale-y-0'}`}>
        <div id="nav-dialog" class="w-full h-fit fixed z-10 md:hidden bg-[#122B4A] inset-0 py-6">
          <div id="nav-bar" class="flex justify-between container mx-auto px-3">
            {/* <a href="#" id="brand" class="flex gap-2 items-center">
              <img class="object-cover w-40" src={Logo} alt="Logo" />
            </a> */}
            <h1 className='text-3xl font-semibold text-white'>
              Lung Renew
            </h1>
            <button
              onClick={toggleMenu}
              className="absolute top-4 right-4 text-white focus:outline-none"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          <div class="mt-6 ">

            <a onClick={toggleMenu}
              href="#features" class="text-white hover:text-gray-200 font-medium m-3 p-3 hover:bg-[#2f5b91] block rounded-lg">
              About Lung Renew

            </a>
            <a onClick={toggleMenu}
              href="#science-back" class="text-white hover:text-gray-200 font-medium m-3 p-3 hover:bg-[#2f5b91] block rounded-lg">
              Ingredients
            </a>
            <a onClick={toggleMenu}
              href="#faqs" class="text-white hover:text-gray-200 font-medium m-3 p-3 hover:bg-[#2f5b91] block rounded-lg">
              FAQ
            </a>
            <div class="flex justify-center w-full px-6">
              <a onClick={toggleMenu}
                href="#pricing" class="w-full"> <button class="bg-blue-100 text-navy-900 px-4 py-2 rounded w-full  hover:bg-white transition-colors">
                  Order Now
                </button></a>
            </div>


          </div>

        </div>

      </div>

      {/* Overlay for Mobile Menu */}
      {isMenuOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={toggleMenu}
        ></div>
      )}
    </header>
  );
};

export default Header;
